import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import {
  Configuration,
  LabResultApi,
  type LabResultApiCumulativeLabResultRequest,
  type LabResultApiDownloadlabResultAttachmentRequest,
  type LabResultApiDownloadlabResultPdfRequest,
  type LabResultApiLabResultRequest,
  type LabResultApiSearchLabResultsRequest,
  type LabResultsSearchResponse,
} from '../generated/openapi/befunde-api';
import { loadUser } from '../oidcConfig.ts';

const api = new LabResultApi(new Configuration({ accessToken: () => loadUser()?.access_token ?? '' }), window._env_.API_URL);

export const useSearchLabResults = (params: LabResultApiSearchLabResultsRequest, timestamp: Date, enabled = true) =>
  useQuery<LabResultsSearchResponse, AxiosError>({
    queryKey: [api.searchLabResults.name, params, timestamp],
    queryFn: async () => {
      const res = await api.searchLabResults(params);
      return res?.data;
    },
    retry: false,
    enabled,
  });

export const loadLabResult = (params: LabResultApiLabResultRequest) => api.labResult(params);

export const loadCumulativeLabResult = (params: LabResultApiCumulativeLabResultRequest) => api.cumulativeLabResult(params);

export const downloadlabResultPdf = (params: LabResultApiDownloadlabResultPdfRequest) =>
  api.downloadlabResultPdf(params, { responseType: 'blob' });

export const useDownloadlabResultAttachment = (params: LabResultApiDownloadlabResultAttachmentRequest) =>
  useQuery<File, AxiosError>({
    queryKey: [api.downloadlabResultAttachment.name, params.orderResultId, params.attachmentId],
    queryFn: async () => {
      const res = await api.downloadlabResultAttachment(params, { responseType: 'blob' });
      return res?.data;
    },
    retry: false,
    enabled: !!params.orderResultId && !!params.attachmentId,
  });
